import { useTransportQuery } from "@/transport"

export const useRunsMetricStringValuesTransport = (
  metricId: string | undefined,
  options?: { enabled?: boolean; isMonitoring?: boolean },
) =>
  useTransportQuery({
    operation: "getUploadedConversationMetricStringValues",
    request: {
      metric_id: metricId ?? "",
      is_monitoring: options?.isMonitoring,
    },
    options: {
      enabled: (options?.enabled ?? true) && !!metricId,
      staleTime: 5 * 60 * 1000,
      select: (response) => response.values ?? [],
    },
  })
